module.exports = __webpack_public_path__ + "static/media/imgMastersDemo.84568b4f.jpg";